<script>
    import http from '../api/http.js';
	import { selectedGroup } from '../store.js';
    import { Button, ButtonGroup, Card, CardBody, CardFooter, CardHeader, Pagination, PaginationItem, PaginationLink, Table, } from 'sveltestrap';
    import WizardProgress from "../components/WizardProgress.svelte";
    import OptionButton from "../components/OptionButton.svelte";
    import Row from "../components/Row.svelte";
    import Expander from "../components/Expander.svelte";
    import Search from '../components/Search.svelte';
    import { vesselDeploymentImage, vesselDeploymentLightImage, attributeDeploymentImage, attributeDeploymentLightImage, generalImage, cogImage, autoDeployImage, includeSubGroupsImage } from '../common/Images.js'
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    let deployment = {
        vessels : [],
        packageVersionId : 0,
        includeSubGroups : true,
        deployToAll: false,
        autoDeploy : false
    }

    let selectedAttribute;
    let pageNumber = 1;
    let totalPageCount = 0;
    let totalVesselCount = 0;
    let previousPageNumber = 0;

    const displayNumbers = [10, 25, 50, 100, 200];

    let displayNumber = displayNumbers[0];

    const setPageNumber = (number) => {
        pageNumber = number;    
    }

    let isSearching = false;
    let searchTerm = '';
    let previousSearchTerm = '';
    let errorMessage = '';
    
    let affectedVessels = [];
    let vessels = [];    
    let packages = [];
    let versions = [];
    let attributes = [];
    let selectedAttributes = [];
    let exceptionVessels = [];
    
    let deploymentTypeHeading = 'Deploy Via Vessel';
    let deploymentTypeDescription = '';

    let packageErrorMessage = '';
    let packageVersionErrorMessage = '';

    const vesselMode = 'vessel';
    const attributeMode = 'attribute';

    const showVessels = 'vessels';
    const showSelectedVessels = 'selectedVessels';

    const showAttributes = 'attributes';
    const showAffectedVessels = 'affectedVessels';

    let vesselTableView = showVessels;
    let attributeTableView = showAttributes;

    let selectedVessels = [];
    let allVesselsSelected = false;
    
    let deploymentType = vesselMode;

    export let visible;

    let selectedPackage = {
        id: 0,
    };

    let selectedVersion = {
        id: 0,
        name: "",
        versionType: ""
    };

    let step2ImageSource = '';

    $: {
		tabItems[1].imageSource = step2ImageSource;
	}

    let showAllSteps = false;
    let activeTabValue = 0;
    let activeTabDescription = 'General Settings'
    let tabItems = [
        {
            value: 0,
            description: "General",
            isComplete: false,
            imageSource: generalImage
        },
        {
            value: 1,
            description: 'Deployment Type',
            isComplete: false,
        },
        {
            value: 2,
            description: "Additional Settings",
            isComplete: false,
            imageSource: cogImage
        }
    ];

    $: {
        activeTabDescription = tabItems[activeTabValue].description;
    }

    $: {
        if (deploymentType === vesselMode) {
        deploymentTypeHeading = 'Deploy Via Vessel';
        deploymentTypeDescription = 'Manually select the vessels you wish to deploy to from the table below.';
        }
        else {
            deploymentTypeHeading = 'Deploy Via Attribute';
            deploymentTypeDescription = 'Deploying via attributes will deploy to all vessels with the attributes you have selected attached to them.';
        }
    }

    $: {
        if ($selectedGroup != undefined) {
            loadPackages();
            getVesselAttributes();
        }
    }

    $: {
        if (deploymentType === vesselMode) {
            step2ImageSource = vesselDeploymentLightImage;
        }
        else if (deploymentType === attributeMode) {
            step2ImageSource = attributeDeploymentLightImage;
        }
    }

    $: {
        selectedAttributes;
        getAffectedVessels()
    }

    $:{
        selectedPackage;
        getVersions(selectedPackage.id);
    }

    $: {
        displayNumber;
        if (previousPageNumber != pageNumber && $selectedGroup != undefined) {
            allVesselsSelected = false;
            previousPageNumber = pageNumber;
        }
        deployment.includeSubGroups;
        loadVessels(selectedPackage.id);
    }

    $:{
        displayNumber;
        pageNumber = 1
    }

    const handleTabClick = (event) => {
		activeTabValue = event.detail.value;
		activeTabDescription = event.detail.description;
	}

    const loadPackages = async() => {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/all/forselect/${$selectedGroup}`);
        packages = await res.json();
        if (packages.length > 0) {
            selectedPackage = packages[0];
            await getVersions(selectedPackage.id);
            packageErrorMessage = "";            
        }
        else {
            packageErrorMessage = "No packages to show. First ensure you have created a package and have the appropriate permissions before creating a deployment.";
            versions = [];
            selectedVersion = {
                id: 0,
                name: "",
                versionType: ""
            };
        }
    }

   const getVersions = async (id) => {
        if (selectedPackage != undefined) {
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/software/version/forselect/${id}/${$selectedGroup}/false`);
            versions = await res.json();
            if (versions.length > 0) {
                selectedVersion = versions[0];
                packageVersionErrorMessage = "";
            }
            else {
                packageVersionErrorMessage = "No versions to show. First ensure you have created a package version and have the appropriate permissions before creating a deployment.";
            }
        }
    }

    const loadVessels = async (packageId) => {
        if ({$selectedGroup} != undefined && packageId != undefined && packageId != 0) {
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/byrepoaccess/${$selectedGroup}/${displayNumber}/${pageNumber}/0/true/${deployment.includeSubGroups}/${packageId}${searchTerm != '' ? `/${searchTerm}` : ''}`);
            if (res.status === 200) {
                let uiVesselCollection = await res.json();
                vessels = uiVesselCollection.vessels;
                totalPageCount = uiVesselCollection.totalPageCount;
                totalVesselCount = uiVesselCollection.noPaginationVesselCount;        
                checkStoredVessels();
            }
            else if (res.status === 404 && searchTerm != "") {
                vessels = [];
                totalPageCount = 0;
                totalVesselCount = 0;
            }
        }
        else {
            vessels = [];
            totalPageCount = 0;
            totalVesselCount = 0;
        }
        vessels = vessels;    
    }

    const searchVessels = async () => { 
        isSearching = true;    
        let interval = setInterval( async () => {
        if (searchTerm != previousSearchTerm) {
            pageNumber = 1;
            loadVessels(selectedPackage.id);   
        }   
        if (!isSearching) {
            clearInterval(interval);
        }
        previousSearchTerm = searchTerm;      
        }, 1000);    
    }

    const selectVessel = (vessel) => {
        if (vessel.selected) {
            selectedVessels.push(vessel);
        }
        else {
            selectedVessels = selectedVessels.filter(v => v.id != vessel.id);
        }
        selectedVessels = selectedVessels;
        vessels = vessels;
    }

     const toggleSelectAllVessels = () => {
        if (allVesselsSelected) {
            vessels.forEach(vessel => {
                vessel.selected = true;
                if (!selectedVessels.map(v => v.id).includes(vessel.id)) {
                    selectedVessels.push(vessel);
                }});
            }
            else {
                vessels.forEach(vessel => {
                vessel.selected = false;
                selectedVessels = [];
            });
        }
        vessels = vessels;
        selectedVessels = selectedVessels;
    }

    const checkStoredVessels = () => {
        vessels.forEach(vessel => {
        if (selectedVessels.map(v => v.id).includes(vessel.id)) {
            vessel.selected = true;
        }});
    }

   const getAffectedVessels = async () => {
        let attributesCsv = "";
        selectedAttributes.forEach(attribute => {
            attributesCsv += attribute.id.toString() + ",";
        });
        attributesCsv = attributesCsv.slice(0, -1);
        if (attributesCsv != "") {
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/vessels/${$selectedGroup}/${attributesCsv}/${deployment.includeSubGroups}/${selectedPackage.id}/vesselsbyattribute`);
            if (res.status === 200) {
                let uiAffectedVessels = await res.json();
                affectedVessels = uiAffectedVessels.affectedVessels;
                exceptionVessels = uiAffectedVessels.exceptionVessels;
            }
            else {
                affectedVessels = [];
                exceptionVessels = [];
            }
        }  
        else {
            affectedVessels = [];
            exceptionVessels = [];
        }      
    }

    const getVesselAttributes = async () => {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/vessel/true/${$selectedGroup}`);
        attributes = await res.json(); 
        selectedAttribute = attributes[0];
        if (attributes.length == 0) {
            selectedAttributes = [];
        }
    }

    const addVesselAttribute = (attribute) => {
        if (!selectedAttributes.includes(attribute)) {
            selectedAttributes.push(attribute);
            selectedAttributes = selectedAttributes;
            errorMessage = "";
        }
        else{
            errorMessage = "Cannot add duplicate attributes";
        }
    }

    const validateDeployment = () => {
        errorMessage = "";
        if (deploymentType === vesselMode) {
            if (selectedVessels.length === 0) {
                errorMessage = "Please select at least one vessel";
            }
        }
        else if (deploymentType === attributeMode) {
            if (selectedAttributes.length === 0) {
                errorMessage = "Please select at least one attribute";
            }
        }
        else if (selectedVersion.id === 0) {
            errorMessage = "Please select a package version";
        }
    }
    
    const createDeployment = async () => {
        deployment.packageVersionId = selectedVersion.id;
        if (deploymentType === vesselMode) {
            if (selectedVessels.length > 0) {
                deployment.vessels = selectedVessels;
            }
        }
        else if (deploymentType === attributeMode) {
            deployment.vessels = affectedVessels;
        }
        validateDeployment();
        if (errorMessage != "") {
            return;
        }
        const res = await http.post(window.apiBaseUrl + `/deploy/dashboard/deployments/${$selectedGroup}`, deployment);
        if (res.status === 200) {
            visible = false;
            dispatch('deploymentCreated');
        }
        else {
            errorMessage = "Error creating deployment";
        }
    }

    const removeVesselAttribute = (attribute) => {
        if (selectedAttributes.includes(attribute)) {
            selectedAttributes = selectedAttributes.filter((a) => a.id != attribute.id);
            selectedAttributes = selectedAttributes;
        }
    }

    const setDeploymentType = (type) => {
        deploymentType = type;
        resetSelections();
    }

    const resetSelections = () => {
        if (deploymentType === vesselMode) {
            vessels.forEach(vessel => {
                vessel.selected = '';
            });
            allVesselsSelected = '';
            selectedVessels = [];
        }
        else if (deploymentType === attributeMode) {
            selectedAttributes = [];
        }
    }

    const setVesselTableView = (view) => {
        vesselTableView = view;
    }

    const setAttributeTableView = (view) => {
        attributeTableView = view;
    }

    const onPrevious = () => {
		activeTabValue--;
	}

	const onNext = () => {
		activeTabValue++;
	}

    const cancelCreateDeployment = () => {
		visible = false;
	}
    
</script>

<div class="d-flex">
	<div class="breadcrumb">
		<span class="mr-3 cancel" on:mousedown={() => cancelCreateDeployment()} id="go-back-link">Go Back</span>
		<div class="vl mr-3"></div>
		<span>Deployments</span> 
		<i class="fa fa-angle-right"></i>
			<span class="active current">Create Deployment</span>
		<i class="fa fa-angle-right"></i>
		<span class="active">{activeTabDescription}</span>
	</div>
</div>

<div class="container">
    <div class="row">
        <h4 class="m-0 font-weight-bold">Create Deployment <span class="text-danger font-weight-normal"> {errorMessage}</span></h4>
    </div>

    <div class="row">
         <div class="col-10 col-md-10 col-sm-12">
            {#if activeTabValue === 0}
            <div class="fade-in-out">
                <Row>
                    <div class="form-group">
                        <label for="software-name">Package Name</label>
                        <select class="form-control" bind:value={selectedPackage} id="package-select">
                            {#each packages as softwarePackage}
                                <option id="select-{softwarePackage.name}" value={softwarePackage}>{softwarePackage.name}</option>
                            {/each}
                        </select>
						<div class="text-danger">{packageErrorMessage}</div>
                    </div>
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Software Package 
                        </h4>
                        <p>Select the software package that you wish to deploy.</p>
                    </div>
                </Row>

                <Row>
                    <div class="form-group">
                        <label for="software-name">Package Version</label>
                        <select class="form-control" bind:value={selectedVersion} id="version-select">
                            {#each versions as version}
                                <option id="select-{version.name}" value={version}>{version.name}</option>
                            {/each}
                        </select>
						<div class="text-danger">{packageVersionErrorMessage}</div>
                    </div>
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Package Version
                        </h4>
                        <p>Select the version of the package you wish to deploy.</p>
                    </div>
                </Row>
            </div>
            {/if}

            {#if activeTabValue === 1}
            <div class="fade-in-out">
                <Row>
                    <div>
                        <label for="jobMode" class="col-form-label mb-2">Deployment Type</label>
                        <div class="d-flex" id="jobMode">
                            <OptionButton active={deploymentType === vesselMode} on:click={() => setDeploymentType(vesselMode)} imageUrl={vesselDeploymentImage} activeImageUrl={vesselDeploymentLightImage} imageHeight="90" imageWidth="90" id="vessel-deployment-type"></OptionButton>
                            <OptionButton active={deploymentType === attributeMode} on:click={() => setDeploymentType(attributeMode)} imageUrl={attributeDeploymentImage} activeImageUrl={attributeDeploymentLightImage} imageHeight="90" imageWidth="90"  id="attribute-deployment-type"></OptionButton>
                        </div>
				    </div>

                    <div class="detail">
                        <h4 class="font-weight-bold">
                            {deploymentTypeHeading}
                        </h4>
                        <p>{deploymentTypeDescription}</p>
                    </div>
                </Row>

                <Row>
                    <div class="form-group d-flex flex-column">
                        <label for="include-subgroups">Include Subgroups</label>
                        <img src="{includeSubGroupsImage}" alt="includeSubGroups">
                    </div>

                    <div class="detail">
                        	<div class="custom-control custom-switch ml-4" id="include-subgroups-switch">
								<input type="checkbox" class="custom-control-input" id="include-subgroups" bind:checked={deployment.includeSubGroups} >
								<label class="custom-control-label font-weight-bold text-primary" for="include-subgroups">Include Subgroups</label>
							</div>	
                        <p>Include subgroups when adding vessels manually or via attributes.</p>	
                    </div>
                </Row>

                {#if deploymentType === vesselMode}
                <Card>
                    <CardHeader>
                        <div class="d-flex row">
                            <h4 class="mt-1 ml-1 font-weight-bold text-primary"><i class="fas fa-ship"></i> Vessels</h4>
                            <div class="col-sm-3">
                                <Search id="deployments-search-input" bind:searchTerm placeholder="Search Vessels..." on:input={() => searchVessels()} on:focusout={() => isSearching =  false}></Search>   
                            </div>
                            <ButtonGroup class="ml-auto">
                                <Button color="primary" id="vessel-button" class="btnGrp" on:click={() => setVesselTableView(showVessels)} active={vesselTableView === showVessels}>Vessels</Button>
                                <Button color="primary" id="selected-vessel-button" class="btnGrp" on:click={() => setVesselTableView(showSelectedVessels)} active={vesselTableView === showSelectedVessels }>Selected Vessels ({selectedVessels.length})</Button> 
                            </ButtonGroup>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                            {#if vesselTableView === showVessels}
                                <thead>
                                    <tr>
                                        <th><input class="mr-2" id="select-all-vessels" type="checkbox" bind:checked={allVesselsSelected} on:change={() => toggleSelectAllVessels()}/>{selectedVessels.length > 0 ? `(${selectedVessels.length})` : ''}</th>       
                                        <th>Account Name</th>
                                        <th>Vessel Name</th>
                                        <th>Subscription Level</th>
                                        <th>Group</th>
                                        <th>Computers</th>
                                    </tr>          
                                </thead>    
                                <tbody>
                                {#if vessels.length === 0}
                                    <tr>
                                        <td colspan="6" class="text-center">No vessels to show</td>
                                    </tr>
                                {:else}
                                    {#each vessels as vessel}            
                                        <tr id="vessel-row-{vessel.name}">
                                            <td><input id="vessel-checkbox-{vessel.id}" type="checkbox" bind:checked={vessel.selected} on:change={() => selectVessel(vessel)}/></td>
                                            <td class="vesselRow">{vessel.account}</td>
                                            <td>{vessel.name}</td>
                                            <td>{vessel.subscriptionLevel}</td>
                                            <td>{vessel.group}</td>
                                            <td>{vessel.computerCount}</td>
                                        </tr>            
                                    {/each}
                                {/if}
                                </tbody>
                            {:else if vesselTableView === showSelectedVessels}
                                <thead>
                                    <tr>
                                        <th>Vessel Name</th>
                                        <th>Account</th>
                                    </tr>          
                                </thead>    
                                <tbody>
                                {#if selectedVessels.length === 0}
                                    <tr>
                                        <td colspan="6" class="text-center">No vessels selected</td>
                                    </tr>
                                {:else}
                                    {#each selectedVessels as vessel}       
                                        {#if ((vessel.account.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) || vessel.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()))}            
                                            <tr id="vessel-row-{vessel.name}">
                                                <td>{vessel.name}</td>
                                                <td>{vessel.account}</td>
                                            </tr>            
                                        {/if}
                                    {/each}
                                {/if}
                                </tbody>
                            {/if}
                            </table>
                        </div> 
                    </CardBody>
                    <CardFooter>
                    {#if vesselTableView == showVessels}
                        {#if vessels.length > 0}
                            <div class="pagination bg-light shadow-none ml-0 d-flex">
                                <small class="mt-3 mr-auto">{pageNumber === 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalVesselCount ? totalVesselCount:pageNumber * displayNumber)} of {totalVesselCount} vessels</small>
                                <div class="mt-2 justify-content-center">

                                <Pagination>
                                    <PaginationItem disabled={pageNumber === 1}>
                                    <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#0"/>
                                    </PaginationItem>
    
                                    <PaginationItem  disabled={pageNumber === 1}>
                                    <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#0" />
                                    </PaginationItem>
    
                                    {#if totalPageCount > 5}
                                    {#each Array(5) as _, count}
                                        {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                                        <PaginationItem active={pageNumber === count + pageNumber} >
                                            <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#0">{pageNumber + count}</PaginationLink>
                                        </PaginationItem>
                                        {:else if pageNumber <= 3}
                                        <PaginationItem active={pageNumber === count + 1} >
                                            <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#0">{count + 1}</PaginationLink>
                                        </PaginationItem>
                                        {:else if pageNumber >= totalPageCount - 2}
                                        <PaginationItem active={pageNumber === totalPageCount - 4 + count} >
                                            <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#0">{totalPageCount - 4 + count}</PaginationLink>
                                        </PaginationItem>
                                        {/if}
                                    {/each}
                                    {:else}
                                    {#each Array(totalPageCount) as _, count}
                                        <PaginationItem active={pageNumber === count + 1} on:click={() => pageNumber === count + 1}>
                                        <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#0">{count + 1}</PaginationLink>
                                        </PaginationItem>
                                    {/each}
                                    {/if}      
    
                                    <PaginationItem disabled={pageNumber === totalPageCount}>
                                    <PaginationLink id="pagination-next-page-button" next href="#0" on:click={() => setPageNumber(pageNumber + 1)} />
                                    </PaginationItem>
                                    
                                    <PaginationItem disabled={pageNumber === totalPageCount}>
                                    <PaginationLink id="pagination-last-page-button" last href="#0" on:click={() => setPageNumber(totalPageCount)}/>
                                    </PaginationItem>
                                </Pagination>
                                
                                </div>
                                <div class="mt-2 ml-auto">
                                <select class="form-select" id="display-number-select" bind:value={displayNumber}>
                                    {#each displayNumbers as displayNumber}
                                    <option value="{displayNumber}" id="select-display-number-{displayNumber}">{displayNumber}</option>
                                    {/each}
                                </select>
                                <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
                                </div>  
                            </div>
                        {/if}
                    {/if}
                    </CardFooter>
                </Card>
                     
                {:else}
                 <Row>
                    <div class="row">
                        <div class="col-6">
                            <select id="attribute-select" class="form-control" bind:value={selectedAttribute}>
                                {#each attributes as attribute}
                                    <option id="attribute-select-option-{attribute.id}" value={attribute}>{attribute.name} | {attribute.value} ({attribute.group})</option>
                                {/each}
                            </select>
                        </div>
                        <div class="col-6">
                            <button id="add-vessel-attribute-button" class="btn btn-outline-primary" on:click={() => addVesselAttribute(selectedAttribute)} disabled={selectedAttribute == undefined}>Add Attribute</button>
                        </div>
                    </div>
                    <div class="detail">
                        <h4 class="font-weight-bold">
                            Vessel Attributes
                        </h4>
                        <p>Select the vessel attribute(s) you wish the deployment to apply to.</p>
                    </div>
                 </Row>

                <Card>
                    <CardHeader>
                        <div class="d-flex row">
                            <h4 class="mt-1 ml-1 font-weight-bold text-primary">{attributeTableView === showAttributes ? "Attributes" : "Affected Vessels" }</h4>
                             <ButtonGroup class="ml-auto">
                                <Button color="primary" id="computer-button" class="btnGrp" on:click={() => setAttributeTableView(showAttributes)} active={attributeTableView === showAttributes}>Attributes</Button>
                                <Button color="primary" id="attribute-button" class="btnGrp" on:click={() => setAttributeTableView(showAffectedVessels)} active={attributeTableView === showAffectedVessels }>Affected Vessels ({affectedVessels.length})</Button> 
                            </ButtonGroup>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                            {#if attributeTableView === showAttributes}
                                <thead>
                                    <tr>
                                        <th>Attribute Name</th>
                                        <th>Attribute Value</th>
                                        <th>Actions</th>
                                    </tr>          
                                </thead>    
                                <tbody>
                                {#each selectedAttributes as attribute}            
                                    <tr id="attribute-row-{attribute.name}">
                                        <td>{attribute.name}</td>
                                        <td>{attribute.value}</td>
                                        <td>
                                            <button class="btn btn-primary btn-sm" on:click={() => removeVesselAttribute(attribute)}><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>            
                                {/each}
                                </tbody>
                                {:else if attributeTableView === showAffectedVessels}
                                  <thead>
                                    <tr>
                                        <th>Vessel Name</th>
                                        <th>Account</th>
                                    </tr>          
                                </thead>    
                                <tbody>
                                {#each affectedVessels as vessel}            
                                    <tr id="vessel-row-{vessel.name}">
                                        <td>{vessel.name}</td>
                                        <td>{vessel.account}</td>
                                    </tr>            
                                {/each}
                                </tbody>
                            {/if}
                            </table>
                        </div> 
                    </CardBody>
                    <CardFooter>

                    </CardFooter>
                    </Card>

                    <Row>
                        <Expander expanderTitle="Show ({exceptionVessels.length}) Excluded Vessels">
                            {#each exceptionVessels as vessel}
                                <div class="mt-2">
                                    <p>{vessel.name} (<span class="text-info">{vessel.account}</span>)</p>
                                    <p class="text-danger">{vessel.exceptionReason}</p>
                                </div>   
                            {/each}
                        </Expander>
                        <div class="detail">
                            <h4 class="font-weight-bold">
                                Excluded Vessels
                            </h4>
                            <p>Vessels that should be affected by this deployment but won't be as well as the reason  are displayed here.</p>
                        </div>
                    </Row>
                {/if}
                </div>
            {/if}

            {#if activeTabValue === 2}
             <div class="fade-in-out">
                <Row>
                    <div class="form-group d-flex flex-column">
                        <label for="include-subgroups">Auto Deploy</label>
                        <img src="{autoDeployImage}" alt="">
                    </div>
                    
                    <div class="detail">
                        <div class="custom-control custom-switch ml-4" id="auto-deploy-switch">
                            <input type="checkbox" class="custom-control-input" id="auto-deploy" bind:checked={deployment.autoDeploy} >
                            <label class="custom-control-label font-weight-bold text-primary" for="auto-deploy">Auto Deploy</label>
                        </div>	
                        <p>Software package will be automatically deployed to the vessel.</p>	
                    </div>
                </Row>

            </div>
            {/if}
            <div class="d-flex">
				<div class="ml-auto mb-4 mt-2">
					<button class="btn btn-outline-secondary" id="cancel-button" on:click={() => cancelCreateDeployment()}>Cancel</button>
					{#if activeTabValue > 0}
					<button class="btn btn-outline-primary ml-2" id="previous-button" on:click={onPrevious}>Previous</button>
					{/if}
					{#if activeTabValue ===  2}
						<button  class="btn btn-outline-primary ml-2" id="create-button" on:click={() => createDeployment()}>
							<span class="text">Create</span>
						</button>
						{:else if activeTabValue != 2}
						<button class="btn btn-outline-primary" on:click={onNext} disabled={activeTabValue === 2} id="next-button">Next</button>
					{/if}
				</div>
			</div>
         </div>

        <div class="col-2 d-flex">
            <div class="ml-auto fade-in-out delay">
                <WizardProgress bind:activeTabValue={activeTabValue} bind:showAllSteps={showAllSteps} bind:items={tabItems} on:tabClick={handleTabClick}/>
            </div>
        </div>
    </div>
</div>

<style>
    .detail{
		display: flex;
		flex-direction: column;
		justify-content: center;
		max-width: 440px;
	}

	.detail h4{
		font-size: 1em;
		font-weight: 600;
	}

	.detail p{
		font-size: 0.8em;
	}
	
	@media(max-width:1600px){
		.detail h4{
			font-size: 0.9em;
		}

		.detail p{
			font-size: 0.7em;
		}

		.col-10{
			flex: 0 0 68.33333%!important;
		}
	}

	.vl{
		border-left: 1px solid #B9B9B9;
		height: 100%;
	}

    h4{
        color: #233763 ;
		font-size: 1.1em;
    }

	h5{
		color: #233763 ;
		font-size: 1.05em;
	}

	.detail p{
		font-size: 0.9em;
		color: #6C757D;
	}

    @media(min-width: 1200px){
        .container{
            min-width: 1400px!important;
        }

    }

	.text-danger{
		opacity: 0.7;
	}

	.btn-outline-danger {
		margin: 10px;
		padding: 0.2em;
	}

	#cancel-button{
		color: #233763;
		border-color: #233763;
	}

	#cancel-button:hover{
		color: #fff;
		background-color: #233763;
	}

	button:disabled, button[disabled]{
		z-index: 0;
	}

    .disabled{
        opacity: 0.6;
    }

    .form-group img{
        width: 100px;
        height: 100px;
    }

</style>